import { render, staticRenderFns } from "./CardStyle1All.vue?vue&type=template&id=585fdce2&scoped=true&"
import script from "./CardStyle1All.vue?vue&type=script&lang=js&"
export * from "./CardStyle1All.vue?vue&type=script&lang=js&"
import style0 from "./CardStyle1All.vue?vue&type=style&index=0&id=585fdce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585fdce2",
  null
  
)

export default component.exports